/* ============================================================
   CELLEVATE — interacciones (vanilla, sin librerias)
   Robusto para el editor de Shopify: cada init es idempotente
   (no duplica listeners) y se reinicializa al recargar secciones.
   ============================================================ */
(function () {
  "use strict";

  // El archivo se incluye desde varias secciones. Solo el primero enlaza los
  // eventos globales; los demas no hacen nada (evita listeners duplicados).
  if (window.__cellevateBound) return;
  window.__cellevateBound = true;

  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var inEditor = !!(window.Shopify && window.Shopify.designMode);

  /* -------- Reveals + cifras (basado en scroll, no en IntersectionObserver) --
     IntersectionObserver falla en algunos navegadores/entornos y dejaria el
     contenido invisible. Este sistema por scroll funciona en todos, y un
     salvavidas revela cualquier cosa pendiente para que NUNCA quede en blanco. */
  var watchList = [];
  var watchBound = false;
  function processWatch() {
    var vh = window.innerHeight || document.documentElement.clientHeight;
    for (var i = watchList.length - 1; i >= 0; i--) {
      var w = watchList[i];
      var r = w.el.getBoundingClientRect();
      if (r.top < vh * 0.92 && r.bottom > -10) {
        if (w.type === "reveal") w.el.classList.add("mt-visible");
        else runCount(w.el);
        watchList.splice(i, 1);
      }
    }
  }
  function bindWatch() {
    if (watchBound) return;
    watchBound = true;
    var ticking = false;
    function onScroll() {
      if (!ticking) { window.requestAnimationFrame(function () { processWatch(); ticking = false; }); ticking = true; }
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
    window.addEventListener("load", processWatch);
    // Salvavidas: pasados 5 s revela lo que aun quede oculto (anti-blanco).
    setTimeout(function () {
      watchList.slice().forEach(function (w) { if (w.type === "reveal") w.el.classList.add("mt-visible"); });
      watchList = watchList.filter(function (w) { return w.type !== "reveal"; });
    }, 5000);
  }
  function initReveals(root) {
    var els = [].slice.call((root || document).querySelectorAll(".mt-reveal, .mt-reveal--img"));
    if (!els.length) return;
    if (inEditor || reduce) { els.forEach(function (el) { el.classList.add("mt-visible"); }); return; }
    els.forEach(function (el) { if (!el.__mtRev) { el.__mtRev = true; watchList.push({ el: el, type: "reveal" }); } });
    bindWatch();
    processWatch();
    setTimeout(processWatch, 300);
  }
  function runCount(el) {
    if (el.__mtCounted) return;
    el.__mtCounted = true;
    var target = parseFloat(el.getAttribute("data-mt-count"));
    var suffix = el.getAttribute("data-mt-suffix") || "";
    var dec = (el.getAttribute("data-mt-count").split(".")[1] || "").length;
    var start = null, dur = 1600;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = (target * eased).toFixed(dec) + suffix;
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = target.toFixed(dec) + suffix;
    }
    requestAnimationFrame(step);
  }

  /* -------- Marquesinas (duplica el contenido para bucle continuo) -------- */
  function initMarquees(root) {
    (root || document).querySelectorAll("[data-mt-marquee]").forEach(function (track) {
      if (track.dataset.mtCloned) return;
      track.dataset.mtCloned = "1";
      track.innerHTML = track.innerHTML + track.innerHTML;
    });
  }

  /* -------- Parallax suave del hero -------- */
  var parallaxBound = false;
  function initHeroParallax(root) {
    if (reduce || inEditor) return;
    var media = (root || document).querySelector("[data-mt-parallax]");
    if (!media || parallaxBound) return;
    parallaxBound = true;
    var ticking = false;
    function update() {
      var el = document.querySelector("[data-mt-parallax]");
      if (!el || !el.parentElement) { ticking = false; return; }
      var rect = el.parentElement.getBoundingClientRect();
      var offset = Math.max(-60, Math.min(60, rect.top * -0.08));
      el.style.transform = "translateY(" + offset + "px) scale(1.08)";
      ticking = false;
    }
    window.addEventListener("scroll", function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* -------- Cifras animadas (count-up) — usa el mismo sistema por scroll -------- */
  function initCounters(root) {
    var nums = [].slice.call((root || document).querySelectorAll("[data-mt-count]"));
    if (!nums.length) return;
    if (reduce || inEditor) {
      nums.forEach(function (n) { n.textContent = n.getAttribute("data-mt-count") + (n.getAttribute("data-mt-suffix") || ""); });
      return;
    }
    nums.forEach(function (n) { if (!n.__mtRev) { n.__mtRev = true; watchList.push({ el: n, type: "count" }); } });
    bindWatch();
    processWatch();
  }

  /* -------- FAQ acordeon -------- */
  function initFaq(root) {
    (root || document).querySelectorAll(".mt-faq__item").forEach(function (item) {
      if (item.__mtFaq) return;
      var q = item.querySelector(".mt-faq__q");
      var a = item.querySelector(".mt-faq__a");
      if (!q || !a) return;
      item.__mtFaq = true;
      q.addEventListener("click", function () {
        var open = item.classList.contains("is-open");
        var parent = item.closest(".mt-faq__grid") || document;
        parent.querySelectorAll(".mt-faq__item.is-open").forEach(function (o) {
          if (o !== item) { o.classList.remove("is-open"); o.querySelector(".mt-faq__a").style.maxHeight = null; }
        });
        if (open) { item.classList.remove("is-open"); a.style.maxHeight = null; }
        else { item.classList.add("is-open"); a.style.maxHeight = a.scrollHeight + "px"; }
      });
    });
  }

  /* -------- Galeria de la pagina de producto -------- */
  function initPdpGallery(root) {
    var main = (root || document).querySelector("[data-mt-pdp-main]");
    if (!main) return;
    (root || document).querySelectorAll("[data-mt-pdp-thumb]").forEach(function (t) {
      if (t.__mtThumb) return;
      t.__mtThumb = true;
      t.addEventListener("click", function () {
        var src = t.getAttribute("data-src");
        if (!src) return;
        main.src = src;
        document.querySelectorAll("[data-mt-pdp-thumb]").forEach(function (x) { x.classList.remove("is-active"); });
        t.classList.add("is-active");
      });
    });
  }

  /* -------- Cantidad -------- */
  function initPdpQty(root) {
    (root || document).querySelectorAll("[data-mt-qty]").forEach(function (wrap) {
      if (wrap.__mtQty) return;
      wrap.__mtQty = true;
      var input = wrap.querySelector("input");
      var minus = wrap.querySelector("[data-mt-qty-minus]");
      var plus = wrap.querySelector("[data-mt-qty-plus]");
      if (!input) return;
      if (minus) minus.addEventListener("click", function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
      if (plus) plus.addEventListener("click", function () { input.value = (parseInt(input.value, 10) || 1) + 1; });
    });
  }

  /* -------- Selector de variantes -------- */
  function initPdpVariants(root) {
    var rt = (root || document).querySelector("[data-mt-variants]");
    if (!rt || rt.__mtVar) return;
    rt.__mtVar = true;
    var dataEl = document.getElementById(rt.getAttribute("data-mt-variants"));
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var idInput = rt.querySelector("[data-mt-variant-id]");
    var priceNow = rt.querySelector("[data-mt-price-now]");
    var priceWas = rt.querySelector("[data-mt-price-was]");
    var addBtn = rt.querySelector("[data-mt-add]");
    var addLabel = addBtn ? addBtn.querySelector("[data-mt-add-label]") : null;
    var money = rt.getAttribute("data-mt-money") || "{{amount}}";

    function fmt(cents) {
      var v = (cents / 100).toFixed(2);
      return money.replace("{{amount}}", v).replace("{{amount_no_decimals}}", Math.round(cents / 100));
    }
    var selected = {};
    rt.querySelectorAll("[data-mt-option]").forEach(function (group) {
      var name = group.getAttribute("data-mt-option");
      var active = group.querySelector(".is-active");
      selected[name] = active ? active.getAttribute("data-value") : null;
      group.querySelectorAll(".mt-pdp__swatch").forEach(function (sw) {
        sw.addEventListener("click", function () {
          group.querySelectorAll(".mt-pdp__swatch").forEach(function (x) { x.classList.remove("is-active"); });
          sw.classList.add("is-active");
          selected[name] = sw.getAttribute("data-value");
          match();
        });
      });
    });
    function match() {
      var found = variants.find(function (v) {
        return v.options.every(function (o, i) { return selected[v.optionNames[i]] === o; });
      });
      if (!found) return;
      if (idInput) idInput.value = found.id;
      if (priceNow) priceNow.textContent = fmt(found.price);
      if (priceWas) {
        if (found.compare_at_price && found.compare_at_price > found.price) { priceWas.textContent = fmt(found.compare_at_price); priceWas.style.display = ""; }
        else { priceWas.style.display = "none"; }
      }
      if (addBtn) {
        if (found.available) { addBtn.removeAttribute("disabled"); if (addLabel) addLabel.textContent = addBtn.getAttribute("data-label-add"); }
        else { addBtn.setAttribute("disabled", "disabled"); if (addLabel) addLabel.textContent = addBtn.getAttribute("data-label-sold"); }
      }
    }
    match();
  }

  /* -------- Packs / bundles -------- */
  function initPdpBundles(root) {
    var wrap = (root || document).querySelector("[data-mt-bundles]");
    if (!wrap || wrap.__mtBundle) return;
    wrap.__mtBundle = true;
    var tiers = [].slice.call(wrap.querySelectorAll("[data-mt-bundle]"));
    if (!tiers.length) return;
    var form = wrap.closest("form");
    var qtyInput = form ? form.querySelector('input[name="quantity"]') : null;
    var priceNow = document.querySelector("[data-mt-price-now]");
    var priceWas = document.querySelector("[data-mt-price-was]");

    function select(tier) {
      tiers.forEach(function (t) { t.classList.remove("is-active"); });
      tier.classList.add("is-active");
      if (qtyInput) qtyInput.value = tier.getAttribute("data-qty") || "1";
      var p = tier.getAttribute("data-price");
      var c = tier.getAttribute("data-compare");
      if (p && priceNow) priceNow.textContent = p;
      if (priceWas) {
        if (c) { priceWas.textContent = c; priceWas.style.display = ""; }
        else if (p) { priceWas.style.display = "none"; }
      }
    }
    tiers.forEach(function (tier) { tier.addEventListener("click", function () { select(tier); }); });
    select(wrap.querySelector("[data-mt-bundle].is-active") || tiers[0]);

    if (form && !inEditor) {
      form.addEventListener("submit", function (e) {
        var active = wrap.querySelector("[data-mt-bundle].is-active");
        if (!active) return;
        var code = active.getAttribute("data-code");
        var qty = active.getAttribute("data-qty") || "1";
        var idEl = form.querySelector("[data-mt-variant-id]");
        var id = idEl ? idEl.value : null;
        if (!id) return;
        e.preventDefault();
        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: id, quantity: parseInt(qty, 10) || 1 })
        }).then(function () {
          window.location.href = code ? "/cart?discount=" + encodeURIComponent(code) : "/cart";
        }).catch(function () { window.location.href = "/cart"; });
      });
    }
  }

  function start(root) {
    initMarquees(root);
    initReveals(root);
    initHeroParallax(root);
    initCounters(root);
    initFaq(root);
    initPdpGallery(root);
    initPdpQty(root);
    initPdpVariants(root);
    initPdpBundles(root);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { start(); });
  else start();

  // Editor de Shopify: al recargar/seleccionar una seccion, reinicializar
  // solo esa seccion (asi el contenido nunca queda invisible).
  document.addEventListener("shopify:section:load", function (e) { start(e.target); });
  document.addEventListener("shopify:section:select", function (e) { initReveals(e.target); });
  document.addEventListener("shopify:block:select", function (e) { initReveals(e.target.closest(".shopify-section") || document); });
})();
